import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useRef,
  useState,
} from "react";

import { DefaultDrawer } from "./default-drawer";
import { BottomNavigation } from "../bottom-navigation/bottom-navigation";
import { cn } from "~/util/cn";
import { useKeyboardStatus, usePageChange } from "~/util/hooks";

type IDrawerContext = {
  setNavigationIsDisabled: Dispatch<SetStateAction<boolean>>;
};

const DrawerContext = createContext<IDrawerContext>({
  setNavigationIsDisabled: () => void 0,
});

export const useDrawer = (): IDrawerContext => useContext(DrawerContext);

export const Drawer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const drawerId = "side-drawer" as const;
  const drawerRef = useRef<HTMLInputElement>(null);

  usePageChange(() => {
    if (drawerRef.current?.checked) {
      drawerRef.current?.click();
    }
  });

  const [navigationIsDisabled, setNavigationIsDisabled] = useState(false);

  const { isKeyboardOpen } = useKeyboardStatus();

  return (
    <DrawerContext.Provider value={{ setNavigationIsDisabled }}>
      <div className="drawer lg:drawer-open">
        <input
          title="side drawer"
          ref={drawerRef}
          id={drawerId}
          type="checkbox"
          className="drawer-toggle"
        />
        <div className="h-dvh drawer-content grid grid-cols-1 lg:grid-rows-1">
          <div
            className={cn(
              "h-dvh grid grid-cols-1",
              "lg:grid-rows-1",
              isKeyboardOpen
                ? "grid-rows-1"
                : "grid-rows-[calc(100%-4.25rem)_4.25rem]",
            )}
          >
            <div>{children}</div>
            {!isKeyboardOpen ? (
              <BottomNavigation
                disabled={navigationIsDisabled}
                className="h-[4.25rem] lg:hidden"
              />
            ) : null}
          </div>
        </div>
        <DefaultDrawer disabled={navigationIsDisabled} drawerId={drawerId} />
      </div>
    </DrawerContext.Provider>
  );
};
